import {Router} from "../../../stem-core/src/ui/Router";
import {
    DONATE_PAGE_URLS,
    INLINE_DONATION_URLS,
    INLINE_EDIT_DONATION_URLS
} from "../PanelConstants";
import {LoadingSpinner} from "../../ui/LoadingSpinner";
import {PanelToast} from "../PanelToast";
import {Dispatchable} from "../../../stem-core/src/base/Dispatcher";
import {NOOP_FUNCTION} from "../../../stem-core/src/base/Utils";
import {
    apiCancelDonation, apiEditDonationWithCds,
    apiUpdateDonationAmount,
    apiUpdateDonationPaymentMethod, DonationStore
} from "../../../client/state/DonationStore";
import {iFrameUserDataService} from "../../services/IFrameUserDataService";
import {apiDonate, apiDonateWithCds} from "../../../client/state/DonationStore";
import {iFrameState} from "../../services/IFrameState";
import {iFrameMerchantService} from "../../services/IframeMerchantService";
import {PaymentMethodStore} from "../../../client/state/PaymentMethodStore";
import {AnalyticsEventType, dispatchAnalyticsEvent} from "../../../blink-sdk/utils/AnalyticsClient";
import {Messages} from "../../Messages";
import {Money} from "../../../client/state/misc/Money";
import {FLOW_CHECKPOINT, FLOW_TYPE, PANEL_TYPE, PANEL_VARIANT} from "../../../blink-sdk/Constants";
import {Device} from "../../../stem-core/src/base/Device";
import {paymentMethodController} from "./PaymentMethodController";
import {CARD_SECTION_STATE} from "./PaymentMethodController";
import {addressController} from "../inline-subscription/AddressController";
import {ADDRESS_SECTION_STATE} from "../pages/panels/address/AddressPanel";
import {UserAddressStore} from "../../../client/state/UserAddressStore";
import {sendFlowCheckpoint} from "../flows/FlowController";


class DonateMobileState extends Dispatchable {
    payload = null;

    name = "";
    frequency = null;
    isCustomAmount = false;
    donationAmount = "";
    latestDonationFee = null;
    payDonationFeeCheckboxChecked = false;

    previouslyCanceledDonation = null;

    init() {
        console.assert(iFrameState.panelType === PANEL_TYPE.donation);

        const offer = iFrameMerchantService.getDonationOffer();
        if (offer && !iFrameUserDataService.getActiveRecurringDonation()) {
            if (!offer.hasAmountChoice()) {
                this.donationAmount = offer.predefinedAmounts[0];
            }
            if (!offer.hasFrequencyChoice()) {
                this.frequency = offer.getFrequencyOptions()[0];
            }
        }

        if (iFrameState.variant === PANEL_VARIANT.editRecurring && iFrameUserDataService.getActiveRecurringDonation()) {
            this.updateFromActiveRecurringDonation();
        } else {
            paymentMethodController.update({
                cardSectionState: CARD_SECTION_STATE.chooseCard,
                getChooseCardButtonLabel: () => Device.isMobileDevice() ? Messages.finalizePayment : Messages.selectCard,
                getPayWithAddedCardButtonLabel: () => Device.isMobileDevice() ? Messages.finalizePayment : Messages.continue,
                getScope: () => this.getFrequency().isOneTime() ? PaymentMethodStore.Scope.ONE_TIME_PAYMENT
                    : PaymentMethodStore.Scope.RECURRING_PAYMENT,
                onSelectSuccess: () => {
                    if (!Device.isMobileDevice()) { // TODO: This is not that legit.
                        Router.changeURL(INLINE_DONATION_URLS.donate);
                        return;
                    }
                    this.setPayload({
                        amount: donateMobileState.getTotalAmount(),
                        frequency: donateMobileState.getFrequency(),
                        coversFees: donateMobileState.payDonationFeeCheckboxChecked,
                    });
                    this.donateInlineFlowDonate();
                }
            });
        }
    }

    clear() {
        paymentMethodController.clear();
        this.name = "";
        this.frequency = null;
        this.isCustomAmount = false;
        this.donationAmount = "";
        this.latestDonationFee = null;
        this.payDonationFeeCheckboxChecked = false;
    }

    updateFromActiveRecurringDonation() {
        const donation = iFrameUserDataService.getActiveRecurringDonation();
        if (!donation) {
            this.clear();
        } else {
            this.payDonationFeeCheckboxChecked = donation.isDonationFeePaid();
            this.frequency = donation.frequency;
            this.donationAmount = donation.computeAmount();
            paymentMethodController.update({
                cardSectionState: CARD_SECTION_STATE.chooseCard,
                entry: donation,
                savePaymentMethod: true,
                initialPaymentMethod: donation.getPaymentMethod(),
                selectedPaymentMethod: donation.getPaymentMethod(),
                getChooseCardButtonLabel: () => Messages.updatePaymentMethod,
                getPayWithAddedCardButtonLabel: () => Messages.updatePaymentMethod,
                getScope: () => PaymentMethodStore.Scope.RECURRING_PAYMENT,
                onSelectSuccess: () => Router.changeURL(INLINE_EDIT_DONATION_URLS.donate),
            });
        }
    }

    getFrequency() {
        return this.frequency || iFrameMerchantService.getDonationOffer().defaultFrequency;
    }

    getDonationAmount() {
        const {predefinedAmounts, defaultPredefinedAmountIndex} = iFrameMerchantService.getDonationOffer();
        return this.donationAmount || predefinedAmounts[defaultPredefinedAmountIndex];
    }

    getDonationFee() {
        if (this.donationAmount) {
            this.latestDonationFee = DonationStore.computeFeeFromAmount(this.donationAmount, iFrameMerchantService.merchantId);
        }
        return this.latestDonationFee;
    }

    getTotalAmount() {
        return this.donationAmount + (this.payDonationFeeCheckboxChecked ? this.getDonationFee() : 0);
    }

    setPayload(payload) {
        this.payload = payload;
    }

    getDonation() {
        return iFrameUserDataService.getActiveRecurringDonation();
    }

    isValid() {
        return !!this.donationAmount;
    }

    formatAmount(amount) {
        return new Money(amount, iFrameMerchantService.getDonationOffer().getCurrency()).toString();
    }

    // TODO: These are only here temporarily.

    getDonateComponentButtonLabel() {
        if (!this.donationAmount || !this.getFrequency()) {
            return Messages.donate;
        }
        const formattedAmount = this.formatAmount(this.getTotalAmount());
        const formattedFrequency = this.getFrequency().isOneTime() ? "" : "/" + this.getFrequency().name.toLowerCase();
        return Messages.donateInlineFlowButton(formattedAmount, formattedFrequency);
    }

    shouldRenderDonatePage() {
        return Device.isMobileDevice() && (!this.donationAmount || !this.frequency || iFrameState.allowUserToCoverFees);
    }

    getEditDonationComponentButtonLabel() {
        return !this.donationAmount ? Messages.update : Messages.editDonationInlineFlowButton(
            this.formatAmount(this.getTotalAmount()),
            this.getFrequency().name.toLowerCase()
        );
    }

    getDonatePageEditDonationComponentButtonLabel() {
        return !donateMobileState.donationAmount ? Messages.update : Messages.editDonationInlineFlowButton(
            this.formatAmount(donateMobileState.getTotalAmount()),
            donateMobileState.getFrequency().name.toLowerCase()
        );
    }

    // TODO: Rename all of these methods.

    async donate(successCallback=NOOP_FUNCTION, errorCallback=NOOP_FUNCTION) {
        const donate = async () => {
            LoadingSpinner.show();
            try {
                const apiDonateFunction = iFrameMerchantService.isCDSPaymentMethod() ? apiDonateWithCds : apiDonate;
                const donation = await apiDonateFunction({
                    ...this.payload,
                    recurringOfferId: iFrameMerchantService.getDonationOffer().id,
                    ...(await paymentMethodController.extractPaymentMethodFields()),
                });
                if (donation.isActive() || donation.isFinished()) {
                    LoadingSpinner.hide();
                    sendFlowCheckpoint(FLOW_TYPE.donation, FLOW_CHECKPOINT.complete, {
                        donationId: donation.id,
                        offerId: donation.recurringOfferId,
                        // TODO @Mihai: Change this
                        amount: donation.getPrice().toMainUnitString({includeSymbol: false}),
                        currency: donation.currency.isoCode,
                        recurring: donation.isRecurring(),
                        frequency: donation.frequency.toString()
                    });
                    successCallback();
                }
            } catch (error) {
                paymentMethodController.update({paymentError: error});
                errorCallback();
            } finally {
                LoadingSpinner.hide();
            }
        }

        if (iFrameMerchantService.getDonationOffer().shouldCollectAddress() && !this.payload.userAddressId) {
            addressController.update({
                addressSectionState: ADDRESS_SECTION_STATE.chooseAddress,
                onSelectSuccess: async () => {
                    this.payload.userAddressId = addressController.selectedAddress.id;
                    await donate();
                },
                onSelectCancel: () => {
                    delete this.payload.userAddressId;
                    Router.back();
                },
                continueLabel: Messages.finalizeDonation,
            });
            Router.changeURL(INLINE_DONATION_URLS.address);
        } else {
            await donate();
        }
    }

    async donateInlineFlowDonateDonate() {
        const commonPayload = {
            amount: this.getTotalAmount(),
            frequency: this.getFrequency(),
            coversFees: this.payDonationFeeCheckboxChecked,
        };
        const payload = {
            ...commonPayload,
            ...(await paymentMethodController.extractPaymentMethodFields()),
        };
        this.setPayload(payload);
        dispatchAnalyticsEvent(AnalyticsEventType.ATTEMPT_DONATE, {
            ...commonPayload,
            isCustomAmount: this.isCustomAmount,
        });
        return this.donateInlineFlowDonate();
    }

    async donateInlineFlowDonate() {
        return this.donate(() => Router.changeURL(INLINE_DONATION_URLS.thankYou),
            () => Router.changeURL(INLINE_DONATION_URLS.failed));
    }

    async cancel() {
        const donation = this.getDonation();

        LoadingSpinner.show();
        try {
            await apiCancelDonation(donation.id);
            this.previouslyCanceledDonation = donation;
            Router.changeURL(INLINE_EDIT_DONATION_URLS.cancelSuccess);
            this.clear();
        } catch (error) {
            if (error?.message) {
                PanelToast.showError(error.message);
            }
        } finally {
            LoadingSpinner.hide();
        }
    }

    async updateDonation(donationAmount) {
        const donation = this.getDonation();

        LoadingSpinner.show();
        const handleRequestError = error => {
            LoadingSpinner.hide();
            PanelToast.showError(error?.message || "");
        };

        try {
            if (iFrameMerchantService.isCDSPaymentMethod()) {
                if (this.payload?.paymentInfo) {
                    const activeDonation = iFrameUserDataService.getActiveRecurringDonation();
                    await apiEditDonationWithCds({
                        amount: donationAmount,
                        frequency: activeDonation.frequency,
                        userAddressId: activeDonation.getShippingAddress()?.id || UserAddressStore.all()[0]?.id,
                        recurringOfferId: activeDonation.recurringOfferId,
                        paymentInfo: this.payload.paymentInfo,
                    });
                    Router.changeURL(INLINE_EDIT_DONATION_URLS.thankYou);
                } else {
                    paymentMethodController.update({
                        getPayWithAddedCardButtonLabel: () => Messages.continue,
                        getScope: () => PaymentMethodStore.Scope.RECURRING_PAYMENT,
                        onSelectSuccess: async () => {
                            this.setPayload({
                                coversFees: donateMobileState.payDonationFeeCheckboxChecked,
                                ...paymentMethodController.extractPaymentMethodFields(true)
                            });
                            await this.updateDonation(donationAmount);
                        }
                    });
                    Router.changeURL(INLINE_DONATION_URLS.card);
                }
            } else {
                await apiUpdateDonationAmount(donation.id, donationAmount, this.payDonationFeeCheckboxChecked);
                await apiUpdateDonationPaymentMethod(donation.id, paymentMethodController.selectedPaymentMethod?.id);
                Router.changeURL(INLINE_EDIT_DONATION_URLS.thankYou);
            }
        } catch (error) {
            handleRequestError(error);
        } finally {
            LoadingSpinner.hide();
        }
    }

    async donatePageDonate(changeURL=NOOP_FUNCTION) {
        return this.donate(() => changeURL(DONATE_PAGE_URLS.thankYou),
            () => changeURL(DONATE_PAGE_URLS.paymentFailed, true));
    }

    async donatePageCancel(changeURL=NOOP_FUNCTION) {
        const donation = this.getDonation();

        LoadingSpinner.show();
        try {
            await apiCancelDonation(donation.id);
            this.previouslyCanceledDonation = donation;
            changeURL(DONATE_PAGE_URLS.donationCanceled);
            this.clear();
        } catch (error) {
            // TODO: handle API request errors.
        } finally {
            LoadingSpinner.hide();
        }
    }

    async donatePageUpdateDonation(changeURL=NOOP_FUNCTION) {
        const donation = this.getDonation();

        LoadingSpinner.show();
        try {
            await apiUpdateDonationAmount(donation.id, this.donationAmount, this.payDonationFeeCheckboxChecked);
            await apiUpdateDonationPaymentMethod(donation.id, paymentMethodController.selectedPaymentMethod?.id);
            changeURL(DONATE_PAGE_URLS.donationUpdated);
        } catch (error) {
            // TODO handle API requests errors.
        } finally {
            LoadingSpinner.hide();
        }
    }
}

export const donateMobileState = new DonateMobileState();
